<template>
    <v-container>
        <v-snackbar v-model="alert" timeout="5000" :color="alertType">
            {{ alertContent }}
        </v-snackbar>
        <v-card style="margin-bottom:10px">
            <v-card-title>
            {{$t('incomingCalls')}}
            </v-card-title>
        </v-card>
        <v-dialog v-model="setLangDialog" width="300">
            <v-card>
                <v-card-title primary-title>
                    {{$t('changeLanguageInChannel')}}
                </v-card-title>
                <v-card-text>
                    <v-select v-model="cLang" :label="$t('selectLanguage')" :items="cLangItems" item-text="title" item-value="value"></v-select>
                    {{$t('changeLangNote')}}
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" style="margin-top:-10px;" @click="setLangOk">{{$t('changeLanguage')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-data-table :headers="headers" :items="calls" :items-per-page="-1" class="elevation-1">
            <template v-slot:item.index="{ item }">
                {{ calls.indexOf(item) + 1 }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-btn icon @click="hangup(item)">
                    <v-icon>
                        mdi-phone-off
                    </v-icon>
                </v-btn>
                <v-btn icon @click="setGo(item)">
                    <v-icon>
                        mdi-dialpad
                    </v-icon>
                </v-btn>
                <v-btn icon @click="setLang(item)">
                    <v-icon>
                        mdi-translate
                    </v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        alert: false,
        alertType: '',
        alertContent: '',
        calls: [
        ],
        setLangDialog: false,
        setLangId: '',
        cLang: '',
    }),
    computed: {
        headers() {
            return [
                {
                    text: '#',
                    align: 'start',
                    sortable: false,
                    value: 'index'
                },
                { text: this.$t('dialingNumber'), value: 'did' },
                { text: this.$t('incomingDid'), value: 'callerIdNum' },
                { text: this.$t('callsTimeSeconds'), value: 'duration' },
                { text: this.$t('transfered'), value: 'transferFrom' },
                { text: this.$t('extNumber'), value: 'path' },
                { text: this.$t('actions'), value: 'actions', sortable: false }
            ]
        },
        cLangItems() {
            return [
                { title: this.$t('hebrew'), value: 'he' },
                { title: this.$t('english'), value: 'en' },
                { title: this.$t('yidish'), value: 'de' },
                { title: this.$t('arabic'), value: 'ar' },
                { title: this.$t('spanish'), value: 'es' },
                { title: this.$t('de'), value: 'de1' },
                { title: this.$t('french'), value: 'fr' },
                { title: this.$t('ressian'), value: 'ru' },
                { title: this.$t('am'), value: 'am' },
                { title: this.$t('wap'), value: 'wap' }
            ]
        }
    },
    methods: {
        loadData() {
            (async () => {
                const body = { token: sessionStorage.token };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/GetIncomingCalls`, body);
                this.calls = response.data.calls;
            })();
        },
        hangup(item) {
            (async () => {
                const body = { token: sessionStorage.token, ids: item.id, action: "hangup" };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/CallAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('actionSucess')
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('actionError')
                }
            })();
        },
        setGo(item) {
            (async () => {
                const to = prompt("לאן נעביר את המשתמש (יש לכתוב ללא ה/ בהתחלה)");
                const body = { token: sessionStorage.token, ids: item.id, action: `set:GOasap=/${to}` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/CallAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('actionSucess')
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('actionError')
                }
            })();
        },
        setLang(item) {
            this.setLangDialog = true;
            this.setLangId = item.id;
        },
        setLangOk () {
            (async () => {
                const body = { token: sessionStorage.token, ids: this.setLangId, action: `set:Clanguage=${this.cLang}` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/CallAction`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('actionSucess')
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('actionError')
                }
            })();
        }
    },
    beforeMount() {
        this.loadData()
        setInterval(this.loadData, 1000)
    },
}
</script>